module.exports = __webpack_public_path__ + "img/xmark.e6ed7fb0.svg";